const INIT_STATE = {
   items: []
};

export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SET_SIDEBAR_ITEMS": {
         return { ...state, items: action.payload };
      }
      default:
         return state;
   }
};
